import Vue from 'vue';
import axios from 'axios';
import router from '../router'


let requestList = [];
let removeReqest = (path) => {
    for (var index in requestList) {
        if (path.indexOf(requestList[index]) != -1) {
            requestList.splice(index, 1);
            break;
        }
    }
}

// 添加请求拦截器
axios.interceptors.request.use(
    config => {
        let token = sessionStorage.getItem('token')
        if (token) {
            config.headers.token = token
        }
        if (!(config.method === 'get' || config.method === 'GET')) {
            let requestPath = config.url + '&' + JSON.stringify(config.data)
            if (!(requestList.indexOf(requestPath) === -1)) {
                return Promise.reject(config)
            }
            requestList.push(requestPath)
        }
        return Promise.resolve(config)
    },
    error => {
        return Promise.reject(error)
    })

// 添加响应拦截器
axios.interceptors.response.use(
    response => {
        let parameter = response.config.data instanceof FormData ? JSON.stringify(response.config.data) : response.config.data
        let requestPath = response.config.url + '&' + parameter;
        removeReqest(requestPath)
        let res = response.data;
        if (res.meta.code == 9001003) {
            //调整到无权限访问页面
            router.replace({
                name: 'error_401'
            });
        }
        return response
    },
    error => {
        let parameter = error.data instanceof FormData ? JSON.stringify(error.data) : error.data
        let requestPath = error.url + '&' + parameter;
        removeReqest(requestPath)
        if (error.response) {
            // alert('token过期')
            // router.replace({
            //   path: '/login'
            // })
            // let res = error.response;
            // switch(res.status) {
            //   case 401:
            //     break;
            // }
        }
        return Promise.reject(error);
    })

export default axios;



// WEBPACK FOOTER //
// ./src/lib/axios.js